import * as React from 'react';
import { ActivityAction, ActivityResourceName } from '@pec/aion-ui-core/interfaces/activities';
import { CommonRootState } from '@pec/aion-ui-core/combineReducers';
import { connect } from 'react-redux';
import { Error } from '../../components/Error';
import { fetchOrganizationIfNeeded } from '@pec/aion-ui-core/actions/organization';
import { fetchReportingNotificationsCount } from '@pec/aion-ui-core/actions/fetchReportingNotificationsCount';
import { fetchUserInfoIfNeeded, hasPermission } from '@pec/aion-ui-core/actions/userInfo';
import { Loading } from '../../components/Loading';
import { Location } from 'history';
import { ReportingSection as ReportingSectionComponent } from '../../components/Nav/ReportingSection';
import { RootActions } from '@pec/aion-ui-core/combineActions';
import { ThunkDispatch } from 'redux-thunk';
import { UserInfoActivitiesType } from '@pec/aion-ui-core/interfaces/userInfo';

// Take in location so when it changes, the component re-renders and the active
// link styling is refreshed.

type OwnProps = {
  organizationId: string;
  location: Location;
};

const mapStateToProps = (state: CommonRootState) => ({
  ...state.organization,
  ...state.notifications,
  ...state.userInfo
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<CommonRootState, null, RootActions>,
  { organizationId }: OwnProps
) => ({
  fetchOrganizationIfNeeded: () => dispatch(fetchOrganizationIfNeeded(organizationId)),
  fetchReportingNotificationsCount: () => dispatch(fetchReportingNotificationsCount(organizationId)),
  fetchUserInfoIfNeeded: () => dispatch(fetchUserInfoIfNeeded())
});

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & OwnProps;

class ReportingSection extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    props.fetchOrganizationIfNeeded();
    props.fetchReportingNotificationsCount();
    props.fetchUserInfoIfNeeded();
  }

  hasGlobalPermission = (action: ActivityAction, resourceName: ActivityResourceName) =>
    hasPermission(this.props.userInfo, action, resourceName);

  hasOrganizationPermission = (action: ActivityAction, resourceName: ActivityResourceName) => {
    const { userInfo, organizationId } = this.props;

    return organizationId
      ? hasPermission(userInfo, action, resourceName, [
          {
            type: UserInfoActivitiesType.Organization,
            id: organizationId
          }
        ])
      : false;
  };

  render() {
    const { organization, fetchError, flexTrack, operationalReporting } = this.props;
    return organization ? (
      <ReportingSectionComponent
        hasGlobalPermission={this.hasGlobalPermission}
        hasOrganizationPermission={this.hasOrganizationPermission}
        organizationId={organization.id}
        features={organization.features}
        flexTrackCount={flexTrack}
        operationalReportingCount={operationalReporting}
      />
    ) : fetchError ? (
      <Error />
    ) : (
      <Loading />
    );
  }
}

export const ReportingSectionContainer = connect(mapStateToProps, mapDispatchToProps)(ReportingSection);
